const YOMDEL_ID = "yomdel-script";

function loadYomdel(url) {
  // Remove old script
  const old = document.getElementById(YOMDEL_ID);
  if (old) {
    old.remove();
  }

  // Create new script
  const script = document.createElement("script");
  script.id = YOMDEL_ID;
  script.type = "text/javascript";
  script.async = true;
  script.src = `https://clients.yomdel.com/tools/chat_script.js?url=${encodeURIComponent(
    url
  )}`;

  document.body.appendChild(script);
}

// First load
export const onClientEntry = () => {
  if (typeof window === "undefined") return;

  loadYomdel(window.location.href);
};

// Route change (SPA navigation)
export const onRouteUpdate = ({ location }) => {
  if (typeof window === "undefined") return;

  loadYomdel(location.href);
};